import { render } from "./EditEmploiPage.vue?vue&type=template&id=192b6e8e&ts=true"
import script from "./EditEmploiPage.vue?vue&type=script&lang=ts"
export * from "./EditEmploiPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__